export default __webpack_public_path__ + "static/media/fund-outline.f9338195.svg";